<div content *ngIf="!(_templatesLoading$|async); else isLoading">
  <app-template-library type="report"
                        (onAction)="handleAction($event)"></app-template-library>
  <app-dialog [config]="dialogOpenIframeConfig" #iframeDialog></app-dialog>
  <app-dialog [config]="dialogAddDataSourceConfig" #addDataSourceDialog></app-dialog>
</div>
<ng-template #isLoading>
  <app-loader diameter="35" [enable]="true"></app-loader>
</ng-template>
